import React, { useState, useEffect } from 'react'
import AddCategory from '../components/AddCategory'
import EmployerHeader from '../components/EmployerHeader'
import useAxios from '../utils/useAxios'

function EmployerCategories() {

    let [categories, setCategories] = useState([])
    const [companies, setCompanies] = useState([])
    let api = useAxios()

    useEffect(() => {
        getCategories()
    }, [])

    useEffect(() => {
        getCompanies()
    }, [])

    let getCompanies = async () => {
        let response = await api.get('/api/companies/')
        if (response.status === 200) {
            setCompanies(response.data)
        }
    }

    let getCategories = async () => {
        let response = await api.get('/api/categories/')
        if (response.status === 200) {
            setCategories(response.data)
        }
    }

  return (
    <div>
        <EmployerHeader />
        <div className='container'>
            <div className="d-flex justify-content-between">
                <div><h2>My Companies</h2></div>
                <div><button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#categoryModal">Add Category</button></div>
            </div>

            <div className='row mt-5'>
                {companies.map(company => (
                    <div key={company.id} className='col'>
                        <h5>{company.name}</h5>
                        <ul className="list-group mt-5">
                            {categories.map(category => {
                                if(category.company == company.id) {
                                    return (
                                        <li key={category.id} className="list-group-item">
                                            <span className="fw-bold">{category.name}</span>
                                        </li>
                                    )
                                }
                            }
                            )}
                        </ul>
                    </div>
                ))}
            </div>


        </div>

        <AddCategory />
    </div>
  )
}

export default EmployerCategories